import React from 'react';
export const Header = () => {
  return <header className="w-full py-6" data-id="element-154">
      <div className="container mx-auto px-4 flex justify-center" data-id="element-155">
        <a href="https://www.neurotoned.com" className="w-16 h-16 rounded-full overflow-hidden hover:opacity-90 transition-opacity" data-id="element-156">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rrHy2EJ66VVPMZwVzkfGjw/Healing_isn%E2%80%99t_about_forgetting_%E2%80%94_it%E2%80%99s_about_rewiring.-min.png" alt="Neurotoned Logo" className="w-full h-full object-cover" data-id="element-157" />
        </a>
      </div>
    </header>;
};